import { IProjectCompanyOption } from '@company/projectCompany/projectCompany.models';
import { IOption } from '@gcl/react-core';
import { IProjectUserProfileOption } from '@userProfile/projectUserProfile.models';

export enum ETeamFormKeys {
  COMPANY = 'company',
  COMPANY_ID = 'projectCompanyId',
  NAME = 'teamName',
  ASSIGN_MEMBERS = 'assignMembers',
  ASSIGN_T1 = 'assignT1s',
}

export interface ITeamFormState {
  [ETeamFormKeys.NAME]: string | null;
  [ETeamFormKeys.ASSIGN_MEMBERS]: IProjectUserProfileOption[];
  [ETeamFormKeys.COMPANY]: IOption<IProjectCompanyOption> | null;
}
